import {useState, useEffect} from "react";
import {
    Container,
    Button,
    Table,
    TableHead,
    TableBody,
    TableFooter,
    Grid,
    Modal,
    TextField,
    Select,
    MenuItem,
    InputLabel,
    FormControl
} from "@material-ui/core";

import { DataGrid,
    ptBR
} from '@mui/x-data-grid';

import Pagination from '@material-ui/lab/Pagination';
import { toast  } from 'react-toastify';
import Olho from "@material-ui/icons/RemoveRedEye"
import api from "../../services/api";
import { pode, mensagemErro } from "../../services/acesso";
import { baixarArquivo } from "../../services/download";
import {StyledTableCell,StyledTableRow, useStyles} from '../mailing/ListingMailing/styles';
import {Link} from "react-router-dom";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { LinearProgress } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import EditIcon from '@material-ui/icons/Edit';
import ConfirmDialog from "../../components/ConfirmDialog";
import PageHeader from "../../components/PageHeader";
import StatusChip from "../../components/StatusChip";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import CalendarioReunioes from "./CalendarioReunioes";
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import { FILTROS_VAZIOS, DATA_MIN, DATA_MAX, validarFiltros, montarParams } from "./filtrosAgendamento";

const columns = [
    {
        field: 'actions',
        headerName: 'Ações',
        renderCell: RowMenuCell,
        sortable: false,
        width: 100,
        headerAlign: 'center',
        filterable: false,
        align: 'center',
        disableColumnMenu: true,
        disableReorder: true,
    },
    {
        field: 'numero_reuniao',
        headerName: 'Nº da reunião',
        width: 140,
        filterable: false,
        disableReorder: true,
        sortable: false,

    },
    {
        field: 'tipo_agenda_label',
        headerName: 'Tipo',
        width: 130,
        filterable: false,
        disableReorder: true,
        sortable: false,
    },
    {
        field: 'data_reuniao',
        headerName: 'Data Reunião',
        width: 170,
        type: "date",
        disableReorder: true,
        sortable: false,

    },
    {
        field: 'hora_reuniao',
        headerName: 'Hora Reunião',
        width: 170,
        disableReorder: true,
        sortable: false,
        // A API devolve HH:MM:SS; a tela mostra HH:MM.
        valueFormatter: (params) => (params.value ? String(params.value).slice(0, 5) : ""),
    },
    {
        field: 'customersName',
        headerName: 'Cliente/projeto',
        filterable: false,
        width: 170,
        disableReorder: true,
        sortable: false,

    },
    {
        field: 'corporate_name',
        headerName: 'Razão Social',
        filterable: false,
        width: 170,
        disableReorder: true,
        sortable: false,

    },
    {
        field: 'cargo',
        hide: true,
        headerName: 'Cargo do contato',
        filterable: false,
        width: 170,
        disableReorder: true,
        sortable: false,

    },

    {
        field: 'cnae',
        hide: true,
        headerName: 'CNAE',
        filterable: false,
        width: 170,
        disableReorder: true,
        sortable: false,

    },
    {
        field: 'data_agendamento',
        hide: true,
        headerName: 'Data Agendamento',
        width: 170,
        type: "date",
        disableReorder: true,
        sortable: false,


    },
    {
        field: 'status_auditoria',
        renderCell: (p) => <StatusChip tipo="auditoria" valor={p.value} />,
        headerName: 'Status Auditoria',
        width: 170,
        filterable: false,
        disableReorder: true,
        sortable: false,

    },
    {
        field: 'status',
        renderCell: (p) => <StatusChip tipo="confirmacao" valor={p.value} />,
        headerName: 'Status Agendamento',
        width: 170,
        disableReorder: true,
        sortable: false,

    },
    {
        field: 'enviou_briefing',
        renderCell: (p) => <StatusChip tipo="briefing" valor={p.value} />,
        headerName: 'Status Briefing',
        width: 170,
        filterable: false,
        disableReorder: true,
        sortable: false,

    },
    {
        field: 'assessoresName',
        headerName: 'Assessor',
        width: 170,
        disableReorder: true,
        sortable: false,

    }

];



function RowMenuCell(props) {
    const { api : apiTable, id, row} = props;
    const classes = useStyles();
    const [confirmOpen,setConfirmOpen] = useState(false);

    const handleDeleteClick = (event) => {
        // event.stopPropagation();

        api.delete(`agendamento-lead/${id}`).then(() => {
            apiTable.updateRows([{ id, _action: 'delete' }]);
            toast.success("Reunião excluída");
        }).catch(() => {
            toast.error("Não foi possível excluir a reunião");
        })


    };


    return (
      <div className={classes.root}>
        <IconButton
          size="small"
          component={Link}
          to={"/agendamento-lead/"+row.idAgendamento+"?id_lead="+row.lead_id}
          aria-label="Abrir reunião"
        >
            <EditIcon fontSize="small"/>
        </IconButton>
        {pode("excluir") && (
        <IconButton
          color="inherit"
          size="small"
          aria-label="Excluir reunião"
          onClick={() => setConfirmOpen(true)}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
        )}
        <ConfirmDialog
            title="Excluir reunião?"
            open={confirmOpen}
            setOpen={setConfirmOpen}
            onConfirm={handleDeleteClick}
        >
           A reunião{row.corporate_name ? <> com <b>{row.corporate_name}</b></> : ""} será excluída. Esta ação não pode ser desfeita.
        </ConfirmDialog>
      </div>
    );
}


// O calendário busca um dia por vez (data_reuniao); o período "Reunião de/até" não vai junto,
// senão a API devolveria o período inteiro em cada dia.
const filtrosCalendario = (aplicados) => {
    const { data_reuniao_inicio, data_reuniao_fim, page, pageSize, ...resto } = montarParams(aplicados, 0, [], localStorage.getItem("id_assessor"));
    return resto;
};

const AgendamentoLead = () => {
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [customers, setCustomers] = useState([]);
    const [assessores, setAssessores] = useState([]);

    // "form" = o que está digitado; "aplicados" = o que foi pesquisado.
    // A paginação e o calendário usam sempre os aplicados, para não misturar filtro digitado e não pesquisado.
    const [form, setForm] = useState(FILTROS_VAZIOS);
    const [aplicados, setAplicados] = useState(FILTROS_VAZIOS);
    const [loading, setLoading] = useState(true);
    const [pageSize, setPageSize] = useState(50);
    const [filters, setFilters] = useState([]);

    const alterar = (campo) => (valor) => setForm((atual) => ({ ...atual, [campo]: valor }));

    useEffect(() => {
        //clientes
        (async () => {
            let data = await api.get("customers", {
                params: {
                    pageSize: 99999,
                    status: true, // só clientes ativos no filtro
                }
            });
            setCustomers(data?.data.data);
        })();

        //assessores
        (async () => {
            try {
                let data = await api.get("assessor/get/select");
                setAssessores(data.data);
            } catch(e) {
                console.log(e);
            }
        })();

    }, []);


    // Incrementado em "Pesquisar" para refazer a busca mesmo se já estiver na página 1.
    const [buscaVersao, setBuscaVersao] = useState(0);
    const [visao, setVisao] = useState("lista");

    useEffect(() => {
        getAgendamentos();
    }, [page, filters, aplicados, buscaVersao]);

    // Pesquisar sempre volta para a primeira página.
    const pesquisar = () => {
        const erro = validarFiltros(form);
        if (erro) {
            toast.warning(erro);
            return;
        }
        setPage(0);
        setAplicados({ ...form });
        setBuscaVersao((v) => v + 1);
    };

    const limpar = () => {
        setForm(FILTROS_VAZIOS);
        setPage(0);
        setAplicados(FILTROS_VAZIOS);
        setBuscaVersao((v) => v + 1);
    };

    function handlePage(value) {
        setPage(value);
    }

    async function getAgendamentos() {
        try {
            setLoading(true)

            let data = await api.get(`agendamento-lead/listing`, {
                params: montarParams(aplicados, page, filters, localStorage.getItem("id_assessor"))
            });
            setRows(data.data.data);
            setTotal(data.data.total);
            setPageSize(data.data.per_page);
        } catch(exception) {
            toast.error(mensagemErro(exception, "Não foi possível carregar as reuniões"));
        } finally {
            setLoading(false)
        }
    }

    const onFilterChange = (filterModel) => {
        setPage(0);
        setFilters(filterModel.items)
    };


    const exportAgenda = async () => {
        setLoading(true)
        try {
            await baixarArquivo("agenda-export", "agendas.xlsx");
        } catch (erro) {
            toast.error(erro.message || "Não foi possível exportar as agendas");
        } finally {
            setLoading(false)
        }
    }

    return (
        <Container>
            <PageHeader
                titulo="Reuniões agendadas"
                acoes={
                    <>
                        <ButtonGroup size="small" aria-label="Visualização">
                            <Button variant={visao === "lista" ? "contained" : "outlined"} color={visao === "lista" ? "primary" : "default"} onClick={() => setVisao("lista")}>Lista</Button>
                            <Button variant={visao === "calendario" ? "contained" : "outlined"} color={visao === "calendario" ? "primary" : "default"} onClick={() => setVisao("calendario")}>Calendário</Button>
                        </ButtonGroup>
                        {pode("exportar") && (
                            <Button variant="outlined" onClick={() => exportAgenda()}>
                                Exportar
                            </Button>
                        )}
                        {pode("editar_reunioes") && (
                            <Button variant="contained" color="primary" startIcon={<AddIcon />} component={Link} to={"/agendamento-lead/novo"}>
                                Nova reunião
                            </Button>
                        )}
                    </>
                }
            />
            <div
                  style={{
                    borderRadius: "5px",
                    borderLeftWidth: "1px",
                    borderRightWidth: "1px",
                    border: "1px solid rgba(0, 0, 0, 0.12)",
                    backgroundColor:"#fff",
                    padding:"10px",
                    paddingBottom:"10px",
                    marginBottom: "20px"
                  }}
                >
                <Container>
                  <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                id="filtro_reuniao_de"
                                label="Reunião de"
                                fullWidth
                                type={"date"}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: DATA_MIN, max: DATA_MAX }}
                                value={form.reuniaoDe}
                                onChange={evt => alterar("reuniaoDe")(evt.target.value)}
                                />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                id="filtro_reuniao_ate"
                                label="Reunião até"
                                fullWidth
                                type={"date"}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: DATA_MIN, max: DATA_MAX }}
                                value={form.reuniaoAte}
                                onChange={evt => alterar("reuniaoAte")(evt.target.value)}
                                />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                id="filtro_agendamento_de"
                                label="Agendamento de"
                                fullWidth
                                type={"date"}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: DATA_MIN, max: DATA_MAX }}
                                value={form.agendamentoDe}
                                onChange={evt => alterar("agendamentoDe")(evt.target.value)}
                                />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                id="filtro_agendamento_ate"
                                label="Agendamento até"
                                fullWidth
                                type={"date"}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: DATA_MIN, max: DATA_MAX }}
                                value={form.agendamentoAte}
                                onChange={evt => alterar("agendamentoAte")(evt.target.value)}
                                />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Autocomplete
                            disablePortal
                            id="Clientes"
                            options={customers}
                            onChange={(event, newInputValue) => {
                                alterar("cliente")(newInputValue);
                            }}
                            value={form.cliente}
                            getOptionLabel={(option) => option.name || ""}
                            renderInput={(params) => <TextField {...params} label="Cliente/projeto" />}
                        />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Autocomplete
                            disablePortal
                            id="Assessores"
                            options={assessores}
                            onChange={(event, newInputValue) => {
                                alterar("assessor")(newInputValue);
                            }}
                            value={form.assessor}
                            getOptionLabel={(option) => option.name || ""}
                            renderInput={(params) => <TextField {...params} label="Assessor" />}
                        />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <FormControl fullWidth>
                            <InputLabel id="filtro_tipo_label" shrink>Tipo</InputLabel>
                            <Select
                                labelId="filtro_tipo_label"
                                id="filtro_tipo"
                                value={form.tipoAgenda}
                                displayEmpty
                                onChange={evt => alterar("tipoAgenda")(evt.target.value)}
                            >
                                <MenuItem value="">Todos</MenuItem>
                                <MenuItem value="1">Reunião</MenuItem>
                                <MenuItem value="0">Oportunidade</MenuItem>
                            </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <FormControl fullWidth>
                            <InputLabel id="status_auditoria_label" shrink>Status Auditoria</InputLabel>
                            <Select
                                labelId="status_auditoria_label"
                                id="status_auditoria"
                                value={form.statusAuditoria}
                                displayEmpty
                                onChange={evt => alterar("statusAuditoria")(evt.target.value)}
                            >
                                <MenuItem value="">Todos</MenuItem>
                                <MenuItem value="em_branco">Em Branco</MenuItem>
                                <MenuItem value="2">Aguardando</MenuItem>
                                <MenuItem value="1">Aprovada</MenuItem>
                                <MenuItem value="3">Não aprovada</MenuItem>
                            </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <FormControl fullWidth>
                            <InputLabel id="status_confirmacao_label" shrink>Status Confirmação</InputLabel>
                            <Select
                                labelId="status_confirmacao_label"
                                id="status_confirmacao"
                                value={form.statusConfirmacao}
                                displayEmpty
                                onChange={evt => alterar("statusConfirmacao")(evt.target.value)}
                            >
                                <MenuItem value="">Todos</MenuItem>
                                <MenuItem value="em_branco">Em Branco</MenuItem>
                                <MenuItem value="aguardando">Aguardando</MenuItem>
                                <MenuItem value="confirmado">Confirmada</MenuItem>
                                <MenuItem value="realizada">Realizada</MenuItem>
                                <MenuItem value="reagendada">Reagendada</MenuItem>
                                <MenuItem value="declinada">Declinada</MenuItem>
                                <MenuItem value="aguardando_nova_data">Aguardando nova data</MenuItem>
                                <MenuItem value="nao_aprovada">Não aprovada</MenuItem>
                            </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <FormControl fullWidth>
                            <InputLabel id="enviou_briefing_label" shrink>Status Briefing</InputLabel>
                            <Select
                                labelId="enviou_briefing_label"
                                id="enviou_briefing"
                                value={form.statusBriefing}
                                displayEmpty
                                onChange={evt => alterar("statusBriefing")(evt.target.value)}
                            >
                                <MenuItem value="">Todos</MenuItem>
                                <MenuItem value="em_branco">Em Branco</MenuItem>
                                <MenuItem value="0">Aguardando</MenuItem>
                                <MenuItem value="1">Enviado</MenuItem>
                            </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} style={{ display: "flex", alignItems: "flex-end", gap: 8 }}>
                            <Button onClick={pesquisar} variant="contained" color="primary" startIcon={<SearchIcon />}>
                                Pesquisar
                            </Button>
                            <Button onClick={limpar} variant="text">
                                Limpar
                            </Button>
                        </Grid>
                  </Grid>
                </Container>
            </div>
            {visao === "calendario" ? (
                <CalendarioReunioes
                    buscaVersao={buscaVersao}
                    filtros={filtrosCalendario(aplicados)}
                />
            ) : (
            <>
            {loading && <div style={{width: "100%"}}>
                <LinearProgress/>
            </div>}

            <div style={{ height: 600, width: '100%', paddingTop: "10px" }}>

                <DataGrid
                    pagination
                    rowCount={total}
                    style={{paddingTop:20}}
                    rows={rows}
                    page={page}
                    pageSize={pageSize}
                    loading={loading}
                    columns={columns}
                    rowsPerPageOptions={[pageSize]}
                    localeText={ptBR.props.MuiDataGrid.localeText}
                    paginationMode="server"
                    filterMode="server"
                    onPageChange={handlePage}
                    onFilterModelChange={onFilterChange}
                />
            </div>
            </>
            )}

            {/* <Table>
                <TableHead>
                    <StyledTableRow>
                        <StyledTableCell>Data da Reunião</StyledTableCell>
                        <StyledTableCell>Cliente</StyledTableCell>
                        <StyledTableCell>Data da Agendamento</StyledTableCell>
                        <StyledTableCell>Status (auditoria)</StyledTableCell>
                        <StyledTableCell>Status (confirmação)</StyledTableCell>
                        <StyledTableCell>Ações</StyledTableCell>
                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {rows.map(row => (
                        <StyledTableRow key={row.idAgendamento}>
                            <StyledTableCell>{row.data_reuniao}</StyledTableCell>
                            <StyledTableCell>{row.customersName}</StyledTableCell>
                            <StyledTableCell>{row.data_agendamento}</StyledTableCell>
                            <StyledTableCell>{row.status_auditoria ? row.status_auditoria : "Em Branco"}</StyledTableCell>
                            <StyledTableCell>{row.statusAgendamento ? row.statusAgendamento : "Em Branco"}</StyledTableCell>
                            <StyledTableCell>
                                <Link to={"/agendamento-lead/"+row.idAgendamento+"?id_lead="+row.lead_id}>
                                    <Button variant={"contained"} color={"default"}>
                                        <Olho/>
                                    </Button>
                                </Link>
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
                <TableFooter>
                <div style={{textAlign:"center",paddingTop:"10px",paddingBottom:"10px"}}>
                    <Pagination style={{textAlign:"center"}} count={total} page={page} onChange={handlePage} />
                </div>
                </TableFooter>
            </Table> */}
        </Container>
    )
}

export default AgendamentoLead;